import { ok, safeTry } from "neverthrow";
import { match } from "ts-pattern";
import z from "zod";

import { mustBeDefined, mustParseAny, yesNoSchema } from "@thalamos/common";

import { FormSectionSchema } from "../../types/FormSection.js";
import { IncidentFormTypeSchema } from "../../types/incidentWorkItem.js";
import type { ActionInput } from "../ActionInput.js";

export function getMcaAccompaniment({
  incidentWorkItem,
}: Pick<ActionInput, "incidentWorkItem">) {
  const result = safeTry(function* () {
    const mcaForm = yield* ok(
      incidentWorkItem.forms.find((form) =>
        match(form.formType)
          .with(IncidentFormTypeSchema.enum.mentalCapacityAct, () => true)
          .otherwise(() => false),
      ),
    ).andThen(mustBeDefined());

    const mcaAccompanimentSectionData = yield* ok(
      mcaForm.sections.find((section) =>
        match(section.id)
          .with(FormSectionSchema.enum.mcaAccompaniment, () => true)
          .otherwise(() => false),
      )?.data,
    )
      .andThen(mustBeDefined())
      .andThen(
        mustParseAny(
          z
            .object({
              accompanyingToEmergencyDepartment: z.object({
                value: yesNoSchema,
                valueLabel: z.string(),
              }),
            })
            .loose(),
        ),
      );

    return ok(
      mcaAccompanimentSectionData.accompanyingToEmergencyDepartment.value,
    );
  });

  return result;
}
